import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';

/**
 * 재생 설정
 */
export interface AudioSourceOption {
	/**
	 * 반복 여부
	 * @default false
	 */
	loop: boolean | number;
}

@Injectable({
	providedIn: 'root'
})
/**
 * 소리 서비스
 */
export class AudioService {
	protected _document: HTMLElement;

	constructor(@Inject(DOCUMENT) document: Document) {

		this._document = document.documentElement;
	}

	/**
	 * 재생 대상 반환
	 * @param src
	 */
	source(src: string) {
		return new AudioSource(
			this._document,
			src
		);
	}
}

/**
 * 재생 대상
 */
export class AudioSource {
	protected _document: HTMLElement;
	protected _src: string;
	protected _node!: HTMLAudioElement;

	constructor(document: HTMLElement, src: string) {
		this._document = document;
		this._src = src;
	}

	protected _remove() {
		const {_node} = this;
		if (_node && _node.parentNode) {
			_node.parentNode.removeChild(this._node);
		}
	}

	/**
	 * 재생
	 * @param option
	 */
	play(option: Partial<AudioSourceOption> = {}) {
		option = Object.assign({
			loop: false
		}, option);

		if (this._node) {
			const audio = this._node;
			audio.currentTime = 0;
		} else {
			const audio = document.createElement('audio');
			this._node = audio;

			audio.src = this._src;
			audio.autoplay = true;

			const {loop} = option;
			if (typeof loop === 'boolean') {
				audio.loop = loop;
				audio.onended = () => {
					this._remove();
				};
			} else {
				let remain = loop as number;
				audio.onended = () => {
					if (remain-- > 0) {
						audio.play();
					} else {
						this._remove();
					}
				};
			}

			audio.style.width = '0';
			audio.style.height = '0';
			audio.style.visibility = 'hidden';
			audio.style.position = 'absolute';
			audio.style.overflow = 'hidden';

			this._document.appendChild(audio);
		}
		return this;
	}

	/**
	 * 중단
	 */
	stop() {
		this._remove();
	}
}
